quoteModule.factory('vehicleProductService', ['$http','AppSettings', 'commonRESTCallService', 'erateSessionVarsService', 'imSessionVarsService','$q','rateQuoteRetrievalCoordService','rateQuoteCoordService', 'vehicleProductCoordService',
function ($http, appSettings, commonRESTCallService, erateSessionVarsService, imSessionVarsService,$q,rateQuoteRetrievalCoordService,rateQuoteCoordService, vehicleProductCoordService) {
    //wbh - 6/30/2015 :: Since this service is essentially a pass-thru to the business service
    // we are not going to create a unit test for it. The bulk of the logic is the API call

    var vehProductService = {};
    //retrieve vehicle product by VIN
    vehProductService.getProductsForVehicleByVIN = function(
        dos,
        vehicleVIN,
        odometer,
        certfication,
        usageTypes,
        vehicleInservice,
        dealInfo,
        customerInfo,
        rvInfo,
        quoteSession,
        defaultProductCodes)
    {
        var deferred = $q.defer();

        //format deal info
        var partnerElig = [];
        if (dealInfo != null) {
            partnerElig = mapFinanceEligibilityFields(dealInfo);
        }
        if (rvInfo != null){
            mapRVEligibilityFields(rvInfo, partnerElig)
        }
        if (customerInfo != null){
            mapCustomerEligibilityFields(customerInfo, partnerElig);
        }

        var vehicleInfo = vehicleProductCoordService.getVehicleDetails();

        var productRequest = {
            "dateOfSale" : dos.yyyymmdd(),
            "dealerAccountCode" : erateSessionVarsService.getCurrentDealerAccountCode(),
            "makeModelInfo" : null,
            "partnerSpecificEligibility" : partnerElig,
            "productPlanType" : vehicleInfo.vehicleSaleType,
            "providerCode" : imSessionVarsService.getCurrentProviderCode(),
            "vehicleCertification" : certfication,
            "vehicleIdentificationNumber" : vehicleVIN,
            "vehicleInservice" : vehicleInservice ? vehicleInservice.yyyymmdd() : null,
            "vehicleOdometer" : "" + odometer,
            "vehicleUsageTypes" : (usageTypes || []).length == 0 ? null : usageTypes,
            "quoteSessionNumber" : quoteSession,
            "productCodeFilters" : defaultProductCodes
        };
        //call the service
        var url = appSettings.startSPANVehicleProductSvcURL + "/RetrieveVehicleProductsByVIN";
        commonRESTCallService.postToServer(url, productRequest)
            .success(function(data, status) {
                deferred.resolve(data);
            })
            .error(function(data, status) {
                deferred.reject(status + ' ' + data);
            });

        return deferred.promise;
    };
    //retrieve vehicle products by model identifier
    vehProductService.getProductsForVehicleByModel = function(
        dos,
        vehicleModelId,
        odometer,
        certfication,
        usageTypes,
        vehicleInservice,
        dealInfo,
        customerInfo,
        rvInfo,
        quoteSession,
        defaultProductCodes)
    {
        var deferred = $q.defer();

        var partnerElig = [];
        if (dealInfo != null) {
            partnerElig = mapFinanceEligibilityFields(dealInfo);
        }
        var year = "0";
        if (rvInfo != null){
            mapRVEligibilityFields(rvInfo, partnerElig)
            year = rvInfo.modelYear;
            vehicleModelId = vehicleModelId ? vehicleModelId : 'UNKNOWN';
        }
        if (customerInfo != null){
            mapCustomerEligibilityFields(customerInfo, partnerElig);
        }
        var productRequest = {
            "dateOfSale" : dos.yyyymmdd(),
            "dealerAccountCode" : erateSessionVarsService.getCurrentDealerAccountCode(),
            "makeModelInfo" : {"InternalMakeId" : "", "InternalModelId" : vehicleModelId, "MakeName":"", "ModelName": "", "ModelYear": year, "VehicleIdentification" : "" },
            "partnerSpecificEligibility" : partnerElig,
            "productPlanType" : null,
            "providerCode" : imSessionVarsService.getCurrentProviderCode(),
            "vehicleCertification" : certfication,
            "vehicleIdentificationNumber" : null,
            "vehicleInservice" : vehicleInservice ? vehicleInservice.yyyymmdd() : null,
            "vehicleOdometer" : "" + odometer,
            "vehicleUsageTypes" : usageTypes.length == 0 ? null : usageTypes,
            "quoteSessionNumber" : quoteSession,
            "productCodeFilters" : defaultProductCodes
        };
        //make the service call
        var url = appSettings.startSPANVehicleProductSvcURL + "/RetrieveVehicleProductsByModelDef";
        commonRESTCallService.postToServer(url, productRequest)
            .success(function(data, status) {
                deferred.resolve(data);
            })
            .error(function(data, status) {
                deferred.reject(status + ' ' + data);
            })

        return deferred.promise;

    }

    //retrieve all products by provider
    vehProductService.getAllProductsByProvider = function(
        dos,
        vehicleVIN,
        odometer,
        quoteSession,
        dealerAccountCode,
        providerCode)
    {
        var deferred = $q.defer();
        odometer = odometer ? odometer : "0";
        dos = dos ? dos : Date.today();

        var productRequest = {
            "dateOfSale" : dos.yyyymmdd(),
            "dealerAccountCode" : dealerAccountCode,
            "makeModelInfo" : null,
            "partnerSpecificEligibility" : [],
            "productPlanType" : null,
            "providerCode" : providerCode,
            "vehicleCertification" : "None",
            "vehicleIdentificationNumber" : vehicleVIN,
            "vehicleInservice" : null,
            "vehicleOdometer" : odometer,
            "vehicleUsageTypes" : null,
            "quoteSessionNumber" : quoteSession,
            "productCodeFilters" : null
        };
        //call the service
        var url = appSettings.startSPANVehicleProductSvcURL + "/RetrieveProductsByProvider";
        commonRESTCallService.postToServer(url, productRequest)
            .success(function(data, status) {
                deferred.resolve({status: status, data: data});
            })
            .error(function(data, status) {
                deferred.resolve({status: status, data: data});   // on purposely resolve it even not implemented...
            });

        return deferred.promise;
    };

    var mapFinanceEligibilityFields = function(dealInfo){
        var fieldsArray = [];

        if(dealInfo.financeRate) { fieldsArray.push({"key":"dealApr", "value": dealInfo.financeRate}); }
        if(dealInfo.amountFinanced) { fieldsArray.push({"key":"dealAmountFinanced", "value": dealInfo.amountFinanced}); }
        if(dealInfo.saleType) { fieldsArray.push({"key":"dealSaleType", "value": dealInfo.saleType}); }
        if(dealInfo.termMonths) { fieldsArray.push({"key":"dealTerm", "value": dealInfo.termMonths}); }
        if(dealInfo.MSRP) { fieldsArray.push({"key":"dealMSRP", "value": dealInfo.MSRP}); }
        if(dealInfo.sellingPrice) { fieldsArray.push({"key":"dealPurchasePrice", "value": dealInfo.sellingPrice}); }

        if(dealInfo.providerSpecificData) {
            for(property in dealInfo.providerSpecificData) {
                if(dealInfo.providerSpecificData.hasOwnProperty(property)) {

                    var propValue = dealInfo.providerSpecificData[property];
                    if(angular.isDate(dealInfo.providerSpecificData[property])) {
                        propValue = propValue.yyyymmdd();
                    }

                    fieldsArray.push({"key":property, "value": propValue});
                }
            }
        }
        return fieldsArray;
    }

    var mapRVEligibilityFields= function(rvInfo, eligibleFlexFiels){
        eligibleFlexFiels.push({"key":"rvType", "value": rvInfo.rvType});
        eligibleFlexFiels.push({"key":"rvManuWarrMonths", "value": rvInfo.manuWarrMonths});
        eligibleFlexFiels.push({"key":"rvManuWarrMiles", "value": rvInfo.manuWarrMiles});
        eligibleFlexFiels.push({"key":"rvModelYear", "value": rvInfo.modelYear});
    }

    var mapCustomerEligibilityFields=function(custInfo, eligibleFlexFields){
        eligibleFlexFields.push({"key":"CustomerState", "value": custInfo.state});
        eligibleFlexFields.push({"key":"CustomerZip", "value": custInfo.zip});
    }

    return vehProductService;
}]);
